<div class="d-flex flex-column dl-application">
  <app-header />
  <main class="d-flex flex-row flex-grow-1">
    <app-navigation />
    <div class="d-flex flex-column flex-grow-1">
      @if(!cookieBannerClosed()) {
        <div class="d-flex flex-row align-items-center justify-content-between dl-cookie-header">
          <div class="px-5">
            We use cookies to customize content for your viewing and for analytics.
            If you continue to browse this website, we will assume that you are happy to receive all our cookies.
          </div>
          <div class="align-content-center h-100 dl-cookie-header-close">
            <button type="button" mat-icon-button class="mx-4" (click)="closeCookieBanner()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      }
      @if(appState() && !appState().initialized) {
        <div class="px-5 py-2 dl-app-state-header">
          {{appState().info}}
        </div>
      }
      <div class="flex-grow-1 dl-content">
        <router-outlet />
      </div>
    </div>
  </main>
</div>
